import { Clickable, H2, P, Section, Strong } from '@ahmdigital/ui';
import styled from 'styled-components';

const StyledSection = styled(Section)`
  padding: 0;
  margin-bottom: 2rem;
`;

const MakeAClaim = () => (
  <StyledSection id="makeAClaim">
    <H2 variant="marginBottomSpacer10">How to make a claim</H2>
    <P>
      The life insurance claims process has been designed to get your claim settled as quickly as possible, so there’s
      one less thing for you or your family to worry about. One of our helpful team members will discuss the process
      with you and organise the necessary documentation to be sent out to you.
    </P>
    <P>
      If you think you may need to make a claim,{' '}
      <Strong>
        get in touch on <Clickable to="tel:1300052584">1300 052 584</Clickable>.
      </Strong>
      <br /> We’re here to help from 8am - 8pm Monday to Friday (AEST).
    </P>
    <P>
      Alternatively, you (your validly nominated beneficiary or your legal personal representative) can write to us on:
      <br />
      Claims Services ahm life insurance
      <br />
      Reply Paid 6728
      <br />
      Baulkham Hills NSW 2153
      <br />
    </P>
    <P>
      Further information about making a claim can be found in the relevant{' '}
      <Clickable to="#formsAndGuides">product disclosure statements</Clickable>.
    </P>
  </StyledSection>
);

export default MakeAClaim;
